import axiosInstance from "../api/axiosInstance";
import { buildAuthHeaders } from "../api/authHeaders";
import {
  logCheckStripeSubscriptionResult,
  logStripeCheckoutSessionCreateResult,
} from "../utils/datadogLogger";

const unwrapResponse = (response) => response?.data?.data || response?.data || {};
const stripTrailingSlashes = (value = "") => value.replace(/\/+$/, "");

const getCheckoutBaseUrl = () => {
  const configuredBase =
    process.env.REACT_APP_FRONTEND_URL ||
    process.env.REACT_APP_APP_URL ||
    process.env.REACT_APP_BASE_URL ||
    "";

  if (configuredBase) return stripTrailingSlashes(configuredBase);
  if (typeof window !== "undefined" && window.location?.origin) {
    return stripTrailingSlashes(window.location.origin);
  }
  return "";
};

export const subscriptionService = {
  async checkSubscription(jwtToken) {
    try {
      const response = await axiosInstance.get("/api/check_stripe_subscription", {
        headers: buildAuthHeaders(jwtToken),
      });
      const data = unwrapResponse(response);

      logCheckStripeSubscriptionResult(
        response?.status || 200,
        data?.subscription_status || null,
        Boolean(data?.has_access),
        null
      );

      return data;
    } catch (error) {
      const responsePayload = error?.response?.data?.data || error?.response?.data || {};
      logCheckStripeSubscriptionResult(
        error?.response?.status || 500,
        responsePayload?.subscription_status || null,
        Boolean(responsePayload?.has_access),
        error?.response?.data?.message ||
          error?.message ||
          "Failed to check subscription status."
      );
      throw error;
    }
  },

  async createSubscription(jwtToken, payload) {
    const intervalRaw = payload?.interval;
    const checkoutBaseUrl = getCheckoutBaseUrl();
    const successUrl =
      payload?.success_url ||
      `${checkoutBaseUrl}/yearsdashboard?subscription=success`;
    const cancelUrl = payload?.cancel_url || `${checkoutBaseUrl}/subscription`;

    const requestPayload = {
      plan_type: payload?.plan_type,
      interval: intervalRaw,
      ...(successUrl ? { success_url: successUrl } : {}),
      ...(cancelUrl ? { cancel_url: cancelUrl } : {}),
    };

    const requestConfig = {
      headers: {
        "Content-Type": "application/json",
        ...buildAuthHeaders(jwtToken),
      },
    };
    const planKey =
      [payload?.interval, payload?.plan_type].filter(Boolean).join("_") ||
      payload?.plan_type ||
      null;

    try {
      const response = await axiosInstance.post(
        "/api/create_stripe_checkout_session",
        requestPayload,
        requestConfig
      );
      const data = unwrapResponse(response);

      if (data?.success === false) {
        const error = new Error(
          data?.message || "Failed to create checkout session."
        );
        error.response = {
          ...response,
          data,
        };
        throw error;
      }

      logStripeCheckoutSessionCreateResult(
        null,
        planKey,
        response?.status || 200,
        data?.checkout_session_id || data?.session_id || null,
        requestPayload,
        data,
        null
      );

      return data;
    } catch (error) {
      logStripeCheckoutSessionCreateResult(
        null,
        planKey,
        error?.response?.status || 500,
        error?.response?.data?.checkout_session_id ||
          error?.response?.data?.session_id ||
          null,
        requestPayload,
        error?.response?.data || {},
        error?.response?.data?.message ||
          error?.message ||
          "Failed to create checkout session."
      );
      throw error;
    }
  },
};
